import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotFoundSpeechBubble = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 64,
	height: 44,
	viewBox: "0 0 64 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 2147226955",
		children: [
			/* @__PURE__ */ _jsx("ellipse", {
				id: "Ellipse 7451",
				cx: 32,
				cy: 22,
				rx: 32,
				ry: 22,
				fill: "#373C46"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 7452",
				cx: 18,
				cy: 22,
				r: 4,
				fill: "#C2C8CF"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 7453",
				cx: 32,
				cy: 22,
				r: 4,
				fill: "#C2C8CF"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 7454",
				cx: 46,
				cy: 22,
				r: 4,
				fill: "#C2C8CF"
			})
		]
	})
});
export default SvgNotFoundSpeechBubble;
